export enum BaseState {
  loading,
  error,
  success,
}
